export default "__VITE_ASSET__TZ4jB1yN__"